let captions: any = {};

export function initCaptions(language: string) {
    captions = require(`@/assets/locales/${language}.json`);
}

export function caption(key: string, replace?: any[] | null): string {
    if (!captions[key]) { return key; }
    
    let text = captions[key];
    
    if (replace) {
        replace.forEach(x => {
            text = text.replace(`{${x.key}}`, x.text);
        });
    }

    return text;
}